export default __webpack_public_path__ + "static/media/logo_nidos_ba.04b45c8a.png";